import styled from 'styled-components';
import { Checkbox } from '@insly/qmt-reactjs-ui-lib';

export const DrawerParticipantRoleWrapper = styled.div`
  display: flex;
`;

export const DrawerParticipantRoleCheckbox = styled(Checkbox)`
  margin-right: 40px;
`;
